<template>
  <div class="wrapper">
        <div class="modal-error__header">      
            {{ title }}         
        </div>
        <IconClose class="close" @click="closeHandle"></IconClose>
        
        <i class="letter-animal" :class="{'big': isModalErrorLoading}"></i>
    </div>
</template>

<script>
import IconClose from "../elements/icons/IconClose.vue";

export default {
    name: 'Modal',
    components: {
        IconClose,
    },
    props: {
        title: {
            type: String,
            require: true
        }
    },
    computed: {
        isModalErrorLoading() {
            return this.$store.getters.getModalErrorLoading;
        }
    },
    methods: {
        closeHandle() {
            this.$emit("closeModalErrorOpen", true);
            this.$emit("closeModalErrorLoading", true);
            this.$store.dispatch("changeModalBackdrop", false);
        },
    }
}
</script>
